/**
 * Formats a duration in seconds as HH:mm:ss, where the hours are the TOTAL hours of the duration.
 *
 * "dayjs.duration(seconds, 'seconds').format('HH:mm:ss')" must not be used for this - its "HH"
 * token is the hours within a day, so it silently drops the days: a duration of 25 hours and one of
 * a single hour both render as "01:00:00".
 *
 * A negative or a non finite value is treated as zero - the modulo arithmetic below would render it
 * as garbage, and neither can happen for a real duration.
 */
export const formatDurationAsHours = (totalSeconds: number): string => {
    const seconds: number = Number.isFinite(totalSeconds) ? Math.max(0, Math.round(totalSeconds)) : 0;
    const hours: number = Math.floor(seconds / 3600);
    const minutes: number = Math.floor((seconds % 3600) / 60);

    return [hours, minutes, seconds % 60].map((value) => String(value).padStart(2, '0')).join(':');
};
